import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class AvailableAppService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/AvailableApps`);
    }

    public readAvailableAppsWithFilters(
        editionID: number,
        systemSectorID: number,
        systemCountryID: number
    ): Promise<IEntity[]> {

        const qs = `GetAvailableAppsWithFilters?editionID=${editionID}&systemSectorID=${systemSectorID}&systemCountryID=${systemCountryID}`;
        return this.readAll(qs);
    }
}